<div class="h-full grid place-content-center full-heigth">
  <div class="px-5">
    <p class="text-[5rem] md:text-[8rem]">Oops...</p>
    <!-- <p class="md:text-lg">No logramos encontrar el recurso que solicitaste.</p> -->
    <p class="md:text-lg">Es posible que el recurso que solicitaste haya sido movido, renombrado, eliminado o nunca
      existió.</p>
  </div>
</div>